import React from "react";
import "../../styles/common/webp-image.scss";

interface IProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>{
  src: string,
  additionalClassName?: string;
}

/**
 * This component uses 2 images, the one specified by the src parameter,
 * paired with a webp source whose URL is generated by simply replacing the extension with ".webp".
 * The WebP file should exist with public S3 permissions.
 * @deprecated use DynamicImage instead
 * @param src The source (src) of the first image.
 * @param additionalClassName
 * @param props
 */
export default function WebPImage({src, additionalClassName="", ...props}: IProps) {
  const srcWithoutExtension = src.substring(0, src.lastIndexOf("."));
  return (
    <picture className={`webp-image ${additionalClassName}`}>
      <source srcSet={`${srcWithoutExtension}.webp`} type="image/webp"/>
      <img src={src} {...props}/>
    </picture>
  );
}